import { render, staticRenderFns } from "./OrderCustomerKnowInfos.vue?vue&type=template&id=e252dfcc"
import script from "./OrderCustomerKnowInfos.vue?vue&type=script&lang=js"
export * from "./OrderCustomerKnowInfos.vue?vue&type=script&lang=js"
import style0 from "./OrderCustomerKnowInfos.vue?vue&type=style&index=0&id=e252dfcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports